<template>
	<div class="update-app-page">
		<t-update-version
			@update-now="updateNow"
		/>
	</div>
</template>

<script>
import { mapActions } from 'vuex'
import { storeKeyNameSpace } from '@/constants/stores'
import { types as typesAuth } from '@/modules/auth/constant'
export default {
	name : 'UpdateApp',
	metaInfo: {
		title: 'Update',
	},
	data :() => ({
		isDisabled: false
	}),
	methods:{
		...mapActions({
            saveUpdateApp : `${storeKeyNameSpace.UPDATE_APP}/saveUpdateApp`,
            getStore: typesAuth.actions.GET_STORE
		}),
		updateNow(){
			this.isDisabled = true
			this.saveUpdateApp().then(async res => {
				let { status } = res.data
				if(status){
					this.toastSuccess({title: 'Update app successful'})
                }
                await this.getStore()
				this.isDisabled = false
                this.$router.push({name: this.$routerName.DASHBOARD})
			}).catch((err)=>{
				console.log(err)
			})
		}
	}
}
</script>

<style lang="scss">
</style>
